import { Box } from "@biom3/react";
import { useIsLessThanXXLargeScreen } from "@ui-kit";
import Image from "next/image";

export const RedemptionRewardsBackground = () => {
  const isXLargeScreen = useIsLessThanXXLargeScreen();

  return (
    <Box
      sx={{
        position: {
          default: "absolute",
        },
        top: "0",
        right: "0",
        width: "100%",
        height: "1000px",
        zIndex: 0,
        display: isXLargeScreen ? "none" : "block",
        overflow: "hidden",
      }}
    >
      <Image
        src="/images/redemption-reward-bg.svg"
        alt="Redemption Rewards Background"
        width={650}
        height={650}
        style={{
          objectFit: "contain",
          maxWidth: "100%",
          height: "auto",
          transform: "translateY(-15px)",
          position: "absolute",
          top: 0,
          right: 0,
        }}
        priority
      />
    </Box>
  );
};
